/**
 * @group Constants
 * 
 * @summary
 * <blockquote>Email subject lines for contact form submissions</blockquote>
 * 
 * @remarks
 * These subject lines are used when sending contact form emails
 * to different internal departments based on form type.
 * 
 * @example
 * ```typescript
 * import { CONTACT_FORM_EMAIL_SUBJECTS } from '@shared/constants';
 * 
 * const subject = formType === 'demo'
 *   ? CONTACT_FORM_EMAIL_SUBJECTS.EMPLOYER_DEMO_REQUEST
 *   : CONTACT_FORM_EMAIL_SUBJECTS.CLINICIAN_APPLICATION;
 * ```
 */
export const CONTACT_FORM_EMAIL_SUBJECTS = {
  EMPLOYER_DEMO_REQUEST: 'New Employer Demo Request',
  CLINICIAN_APPLICATION: 'New Clinician Application',
} as const;
